function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.5 5.5A1.5 1.5 0 012 4h11a1.5 1.5 0 011.5 1.5v1a1 1 0 011 1v1a1 1 0 01-1 1v1A1.5 1.5 0 0113 12H2a1.5 1.5 0 01-1.5-1.5v-5zm12 0a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-10A.5.5 0 012 10V6a.5.5 0 01.5-.5h10z",
  fill: "currentColor"
})));